import { render, staticRenderFns } from "./team-performance-global.vue?vue&type=template&id=46b8a710&"
import script from "./team-performance-global.vue?vue&type=script&lang=js&"
export * from "./team-performance-global.vue?vue&type=script&lang=js&"
import style0 from "./team-performance-global.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports